import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { useI18n } from '../contexts/I18nContext';

export default function FAQ() {
  const { t } = useI18n();
  const items = [
    { q: t('faq.q1'), a: t('faq.a1') },
    { q: t('faq.q2'), a: t('faq.a2') },
    { q: t('faq.q3'), a: t('faq.a3') },
    { q: t('faq.q4'), a: t('faq.a4') },
    { q: t('faq.q5'), a: t('faq.a5') },
  ];
  return (
    <section className="py-20 lg:py-28 bg-[#FAF3EE]" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-5 md:px-10">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 text-[#E5614C] font-semibold uppercase tracking-[0.18em] text-[12px]">
            <span className="h-[2px] w-8 bg-[#E5614C]" /> {t('faq.eyebrow')}
          </div>
          <h2 className="font-serif-display text-[40px] sm:text-[48px] lg:text-[56px] leading-[1.05] font-bold text-[#2A1B1A] mt-4">
            {t('faq.title1')} <span className="italic text-[#E5614C]">{t('faq.title2')}</span>
          </h2>
          <p className="mt-4 text-[16px] text-[#2A1B1A]/70">
            {t('faq.intro')}
          </p>
        </div>

        <Accordion type="single" collapsible className="mt-12 space-y-4">
          {items.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="bg-white rounded-2xl border border-[#2A1B1A]/8 px-6 data-[state=open]:border-[#E5614C]/30 data-[state=open]:shadow-[0_18px_40px_-24px_rgba(229,97,76,0.4)] transition-[border-color,box-shadow] duration-300"
            >
              <AccordionTrigger className="text-left font-semibold text-[16px] lg:text-[17px] text-[#2A1B1A] hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[15px] text-[#2A1B1A]/70 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
